module.exports = {"affective":[],"analytic":[],"process":[],"semantic":[],"episodic":[],"cerebellum":[],"bridge":[],"amygdala":[],"lines":{"affective":[],"analytic":[],"process":[],"semantic":[],"episodic":[]}}


//////////////////
// WEBPACK FOOTER
// ./src/js/data/memories.json
// module id = 2J3f
// module chunks = 1